import { Controller } from "@hotwired/stimulus"

// UX podczas liczenia w Turbo Frame: blokuje przycisk "Oblicz" na czas
// żądania POST, żeby użytkownik nie kliknął dwa razy. Samo liczenie
// (progi, stawki) dzieje się WYŁĄCZNIE po stronie serwera —
// Fees::TaxaCalculator — ten kontroler nic nie liczy, tylko UX.
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.element.addEventListener("turbo:submit-start", this.disable)
    this.element.addEventListener("turbo:submit-end", this.enable)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.disable)
    this.element.removeEventListener("turbo:submit-end", this.enable)
  }

  disable = () => {
    const button = this.submitTarget
    button.disabled = true
    button.dataset.originalValue = button.value
    button.value = "Liczę…"
  }

  enable = () => {
    const button = this.submitTarget
    button.disabled = false
    if (button.dataset.originalValue) button.value = button.dataset.originalValue
  }
}
